// Create separated list
import React from "react";
import Link from "../../elements/Link";
import getClassNameFactory from "../../utilities/classNames";

var SeparatedList = function SeparatedList(_ref) {
  var items = _ref.items,
      separator = _ref.separator;
  var getClassName = getClassNameFactory(SeparatedList.displayName);
  var list = items.map(function (item, index) {
    return item.href && item.text ? /*#__PURE__*/React.createElement(Link, {
      key: index,
      href: item.href
    }, item.text) : item.text;
  }).reduce(function (prev, curr) {
    return [prev, separator, curr];
  });
  return /*#__PURE__*/React.createElement("span", {
    className: getClassName()
  }, list);
};

SeparatedList.displayName = "SeparatedList";
SeparatedList.defaultProps = {
  separator: ", "
};
export default SeparatedList;